import Vue from 'vue'
import Vuex from 'vuex'

import academy from './modules/academy'
import auth from './modules/auth'
import billing from './modules/billing'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    academy,
    auth,
    billing
  }
})
